import * as core from '../../../../../../../core'
import * as pullRequestReviewState from '../pull-request-review-state'

export const RESOURCE = {
  payload: {
    description: 'The latest review requests changes',
    enumId: core.dms.models.Enum.Id.from({
      partialId: pullRequestReviewState.RESOURCE.payload.partialId,
    }),
    id: 'CHANGES_REQUESTED',
    name: 'Changes Requested',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
